import dynamic from 'next/dynamic'
import { customVariants } from './tile-variants-custom'
import { SkeletonCard } from '../../skeleton'

// DON'T USE VARIABLE FOR DYNAMIC OPTIONS, CAUSE Did not expect server HTML to contain a <div> in <div>
/* const dynamicOptions = {
	loading: SkeletonCard,
} */

const TileBase = dynamic(() => import('../base'), {
	loading: SkeletonCard,
})
const TileCompact = dynamic(() => import('../compact'), {
	loading: SkeletonCard,
})
const TileAdvanced = dynamic(() => import('../advanced'), {
	loading: SkeletonCard,
})
const TileList = dynamic(() => import('../list'), {
	loading: SkeletonCard,
})
const TileLook = dynamic(() => import('../look'), {
	loading: SkeletonCard,
})
const TileReview = dynamic(() => import('../review'), {
	loading: SkeletonCard,
})

export const variants = {
	base: TileBase,
	compact: TileCompact,
	advanced: TileAdvanced,
	list: TileList,
	look: TileLook,
	review: TileReview,
	...customVariants,
}
